import { APICore } from 'helpers/api/apiCore'

const api = new APICore()

export function getConfiguracaoKanban() {
  return api.get(`ConfiguracaoKanban/kanban`, null)
}

export function getPipelines() {
  return api.get(`ConfiguracaoKanban/pipelines`, null)
}

export function getPipelinesPaginado(params: {
  pagina: number
  registros: number
  nome: string | null
  status: boolean | null
}) {
  return api.getWithoutUndefined(`ConfiguracaoKanban/pipelines-paginado`, {
    ...params,
    pagina: params.pagina + 1,
    registros: params.registros
  })
}

export function getEtapasPipeline(pipelineId: string) {
  return api.get(`ConfiguracaoKanban/etapas`, { pipelineId })
}

export function getEtapaById(id: string) {
  return api.get(`ConfiguracaoKanban/etapa/${id}`, { id })
}

interface EtapaDto {
  id?: string
  pipelineId: string
  nome: string
  descricao: string
  cor: string
  etapasPermitidas: string[]
  status: boolean
}
export function salvarEtapa(data: EtapaDto) {
  return api.create(`ConfiguracaoKanban/etapa`, data)
}

export function editarEtapa(data: EtapaDto) {
  return api.update(`ConfiguracaoKanban/etapa`, data)
}

export function removerEtapa(id: string) {
  return api.delete(`ConfiguracaoKanban/etapa/${id}`)
}

export function alterarOrdemEtapa({
  id,
  ordem
}: {
  id: string
  ordem: number
}) {
  return api.update(`ConfiguracaoKanban/ordem-etapa`, { id, ordem })
}

export function getBigNumbers() {
  return api.get(`ConfiguracaoKanban/big-numbers-prazos-atendimento`, null)
}

export function getSlaById(id: string) {
  return api.get(`ConfiguracaoKanban/prazo-atendimento/${id}`, { id })
}

export function getEtapas() {
  return api.get(`ConfiguracaoKanban/etapas`, null)
}

export function getAcoes() {
  return api.get(`ConfiguracaoKanban/acoes`, null)
}

interface SlaDto {
  id?: string | null
  etapaId: string
  nome: string
  descricao: string
  prazo: number
  regrasEscalacao: {
    id?: string | null
    disparaEm: string
    acaoId: string
    mensagem: string
  }[]
}
export function salvarSla(data: SlaDto) {
  return api.create(`ConfiguracaoKanban/prazo-atendimento`, data)
}

export function editarSla(data: SlaDto) {
  return api.update(`ConfiguracaoKanban/prazo-atendimento`, data)
}

export function getSLAsConfigurados() {
  return api.get(`ConfiguracaoKanban/prazos-atendimento`, null)
}

export function removerSlaConfigurado(id: string) {
  return api.delete(`ConfiguracaoKanban/prazo-atendimento/${id}`)
}

export function getPipelineById(id: string) {
  return api.get(`ConfiguracaoKanban/pipeline/${id}`, {
    id
  })
}

interface PipelineDto {
  id?: string
  nome: string
  descricao: string
  centroCustoId: string
  quantidadeLeads: number
  site: boolean
}
export function salvarPipeline(data: PipelineDto) {
  return api.create(`ConfiguracaoKanban/pipeline`, data)
}

export function editarPipeline(data: PipelineDto) {
  return api.update(`ConfiguracaoKanban/pipeline`, data)
}

export function removerPipeline(id: string) {
  return api.delete(`ConfiguracaoKanban/pipelines/${id}`)
}

export function alterarStatusPipeline(id: string, status: boolean) {
  return api.update(`ConfiguracaoKanban/status-pipeline`, {
    id,
    status
  })
}

export function duplicarPipeline(id: string) {
  return api.create(`ConfiguracaoKanban/duplicar-pipeline`, {
    id
  })
}

export function getCentrosCusto() {
  return api.get(`Generic/centros-custo`, null)
}
